export const emptyAddress = () => ({
  calle: "",
  num_exterior: "",
  num_interior: "",
  colonia: "",
  localidad: "",
  municipio: "",
  codigo_postal: "",
  estado: "",
  pais: "México",
  referencia: "",
  telefono: "",
  telefono2: "",
});
export const emptyContact = () => ({
  nombre: "",
  apellido_paterno: "",
  apellido_materno: "",
  departamento: "",
  puesto: "",
  email: "",
  telefono: "",
  extension: "",
  enviar_correo: false,
});
export const emptyClient = () => ({
  nombre: "",
  razon_social: "",
  clave: "",
  alias_1: "",
  alias_2: "",
  rfc: "",
  cp_fiscal: "",
  registro_identidad_tributaria: "",
  id_empresa: "",
  id_zona: "",
  id_agente_ventas: "",
  id_agente_cxc: "",
  id_agente_ventas_2: "",
  id_agente_operaciones: "",
  id_fuente: "",
  es_certificador: false,
  enviar_saldos: false,
  dias_envio: "",
  id_clientes_grupo: "",
  id_clientes_tipo: "",
  nombre_contacto: "",
  telefono: "",
  telefono2: "",
  email: "",
  dir_internet: "",
  comentarios: "",
  dias_credito: 0,
  limite_credito: 0,
  descuento: 0,
  iva: 16,
  porcentaje_cliente: 0,
  bloqueado: false,
  permitir_sin_limite: false,
  cheque_posfechado: false,
  enviar_factura: false,
  exportacion: false,
  venta_sin_saldo: false,
  clave_metodo_pago_sat: "",
  metodo_pago_sat: "",
  clave_forma_pago_sat: "",
  forma_pago_sat: "",
  clave_uso_comprobante_sat: "",
  uso_comprobante_sat: "",
  clave_regimen_fiscal_sat: "",
  regimen_fiscal_sat: "",
  direccion_facturacion: emptyAddress(),
  direcciones_entrega: [],
  contactos: [],
  metodos_pago: [],
  productos: [],
  productos_convenio: [],
  addendas: [],
});
export const asBoolean = (value) =>
  value === true || value === 1 || value === "1";
export const cleanObject = (value) =>
  Object.fromEntries(
    Object.entries(value || {}).filter(
      ([, item]) => item !== null && item !== undefined,
    ),
  );
export const addressStarted = (address) =>
  Object.entries(address || {}).some(
    ([key, value]) =>
      ![
        "pais",
        "id",
        "tipo",
        "created_at",
        "updated_at",
        "deleted_at",
      ].includes(key) && String(value ?? "").trim(),
  );
const pivotRows = (rows, foreignKey) =>
  (rows || []).map(({ pivot, ...item }) => ({
    ...item,
    ...(pivot || {}),
    [foreignKey]: item[foreignKey] ?? item.id,
  }));
export function normalizeClientResponse(response) {
  const source =
    response?.data?.data ||
    response?.data ||
    response?.cliente ||
    response ||
    {};
  return {
    ...emptyClient(),
    ...source,
    direccion_facturacion: {
      ...emptyAddress(),
      ...(source.direccion_facturacion ||
        source.direcciones_facturacion?.[0] ||
        source.direccionesFacturacion?.[0]),
    },
    direcciones_entrega:
      source.direcciones_entrega || source.direccionesEntrega || [],
    contactos: source.contactos || [],
    metodos_pago: pivotRows(
      source.metodos_pago || source.metodosPago,
      "id_metodo_pago",
    ),
    productos: pivotRows(source.productos, "id_producto"),
    productos_convenio: pivotRows(
      source.productos_convenio || source.productosConvenio,
      "id_producto",
    ),
    addendas: pivotRows(source.addendas, "id_addenda"),
  };
}
export function buildClientPayload(form) {
  // Lista explícita: no enviar las extensiones de SIASA ni relaciones de lectura.
  const defaults = emptyClient();
  const result = {};
  for (const key of Object.keys(defaults)) {
    if (
      [
        "direccion_facturacion",
        "direcciones_entrega",
        "contactos",
        "metodos_pago",
        "productos",
        "productos_convenio",
        "addendas",
      ].includes(key)
    )
      continue;
    const value = form[key];
    if (
      [
        "id_zona",
        "id_agente_cxc",
        "id_agente_ventas_2",
        "id_agente_operaciones",
        "id_fuente",
      ].includes(key) &&
      (value === "" || value == null)
    ) {
      result[key] = null;
      continue;
    }
    if (
      value == null ||
      (value === "" &&
        (key.startsWith("id_") || typeof defaults[key] !== "string"))
    )
      continue;
    result[key] =
      typeof defaults[key] === "boolean"
        ? asBoolean(value)
        : key.startsWith("id_") || typeof defaults[key] === "number"
          ? Number(value)
          : String(value).trim();
  }
  result.descuento = 0;
  result.cliente_prospecto = 1;
  if (addressStarted(form.direccion_facturacion)) {
    result.direccion_facturacion = cleanObject({
      ...form.direccion_facturacion,
      codigo_postal: form.direccion_facturacion.codigo_postal || form.cp_fiscal,
    });
  }
  result.direcciones_entrega = (form.direcciones_entrega || []).map(
    cleanObject,
  );
  result.contactos = (form.contactos || []).map((row) => ({
    ...cleanObject(row),
    enviar_correo: asBoolean(row.enviar_correo),
  }));
  result.metodos_pago = (form.metodos_pago || []).map((row) =>
    cleanObject({
      id_metodo_pago: Number(row.id_metodo_pago ?? row.id),
      activo: asBoolean(row.activo),
      cuenta: row.cuenta,
      banco: row.banco,
    }),
  );
  result.productos = (form.productos || []).map((row) =>
    cleanObject({
      id_producto: Number(row.id_producto ?? row.id),
      descripcion: row.descripcion,
      precio: Number(row.precio || 0),
      comision: Number(row.comision || 0),
      comision_pct: Number(row.comision_pct || 0),
      vigencia: row.vigencia,
    }),
  );
  result.productos_convenio = form.productos_convenio || [];
  result.addendas = (form.addendas || []).map((row) => ({
    id_addenda: Number(row.id_addenda ?? row.id),
  }));
  return result;
}
export function validateClient(form) {
  const errors = {};
  const requireValue = (key, value, label) => {
    if (!String(value ?? "").trim()) errors[key] = `${label} es obligatorio.`;
  };
  for (const [key, label] of [
    ["nombre", "El nombre"],
    ["cp_fiscal", "El C.P. fiscal"],
    ["id_clientes_grupo", "El grupo"],
    ["id_agente_ventas", "El agente de ventas"],
    ["id_clientes_tipo", "El tipo de cliente"],
  ]) {
    requireValue(key, form[key], label);
  }
  if (form.clave && !/^[\w-]{1,10}$/.test(form.clave))
    errors.clave = "Usa hasta 10 letras, números, guiones o guiones bajos.";
  if (form.email && !/^\S+@\S+\.\S+$/.test(form.email))
    errors.email = "Captura un correo válido.";
  if (form.cp_fiscal && !/^\d{5}$/.test(form.cp_fiscal))
    errors.cp_fiscal = "Captura cinco dígitos.";
  const addresses = [
    ["direccion_facturacion", form.direccion_facturacion],
    ...(form.direcciones_entrega || []).map((address, i) => [
      `direcciones_entrega.${i}`,
      address,
    ]),
  ];
  for (const [prefix, address] of addresses) {
    if (prefix !== "direccion_facturacion" || addressStarted(address)) {
      for (const key of [
        "calle",
        "num_exterior",
        "colonia",
        "municipio",
        "estado",
        "pais",
      ])
        requireValue(
          `${prefix}.${key}`,
          address?.[key],
          `El campo ${key.replace("_", " ")}`,
        );
    }
  }
  (form.contactos || []).forEach((contact, i) => {
    requireValue(
      `contactos.${i}.nombre`,
      contact.nombre,
      "El nombre del contacto",
    );
    if (contact.email && !/^\S+@\S+\.\S+$/.test(contact.email))
      errors[`contactos.${i}.email`] = "Captura un correo válido.";
  });
  return errors;
}
